import $ from 'jquery';

export default function() {
  // Product Article
  // FAQ
  $(document).on('click', '[data-product-faq]', (e) => {
    const $button = $(e.currentTarget);
    $button.toggleClass('State--active');
    $button.find('p').slideToggle(400);
    $button.find('h4').toggleClass('State--active');
  });

  // Whats in it view more on mobile
  $(document).on('click', '[data-view-more]', (e) => {
    e.preventDefault();
    const $view_button = $(e.currentTarget);
    $view_button.closest('.ProductWhatsInIt').toggleClass('State--active');
    $view_button.fadeOut(400);
  });

}
